import { Theme } from './theme.model';
import { DeviceGroup } from './device-group.model';
import { ToroLocationApanSetup } from './toro-location-apan-setup.model';
import { ToroLocation } from './toro-location.model';
import { ScheduleSummary } from './schedule-summary.model';

export class ToroLocationDetailed extends ToroLocation {
    constructor(json: object = null) {
        if (json) {
            super(json);
            Object.assign(this, json);
        }
        else {
            super();
        }
    }

    public DeviceGroups: DeviceGroup[];
    public Themes: Theme[];
    public SceneScheduleSummaryList: ScheduleSummary[];
    public ThemeScheduleSummaryList: ScheduleSummary[];
    public Area: ToroLocationApanSetup;
}
